window.portalModule.directive "appointmentInfo", ['$log', ($log) ->
  restrict: "E"
  scope:
    feedItem: '='
  link: (scope, element, attrs) ->

    scope.status = scope.feedItem.getDetails()

  templateUrl: 'portal/appointments/feed-items/appointment-info/appointment-info-directive-template.html'
]